import React, {useContext} from 'react';
import {observer} from "mobx-react";
import {StoreContext} from "../../../store.context";
import {Space, Table} from "antd";
import {Role} from "../../../types/modules";
import {TableRowActions} from "../../base/action/table/table.row.actions";
import {TranslationDomainEnum} from "../../../types/enums";
import {Translate} from "../../../components/util/translation.util";
import {FilterValue} from "antd/es/table/interface";
import {PaginatorTotal} from "../../../components/table/list/paginator.total";

export const FilterTable: React.FC = observer(() => {
    const {
        appStore: {
            moduleStore: {
                roleStore: {
                    items,
                    list,
                    module,
                    headers,
                    actions,
                    propertyRoutes ,
                    current,
                    pageSize,
                    total,
                    setTablePaginationData,
                    loading
                },
            }
        }
    } = useContext(StoreContext);

    const onPaginationChange = async (
        event: any,
        filters: Record<string, FilterValue | null>,
        sorter: any
    ) => {
        setTablePaginationData({
            current: event.current,
            pageSize: event.pageSize,
            field: sorter.field,
            order: sorter.order
        });

        list();
    }

    return (
        <Space direction={`vertical`} size={`middle`} style={{ display: 'flex' }}>
            <Table
                    dataSource={items}
                    size={`small`}
                    onChange={onPaginationChange}
                    loading={loading}
                    rowKey={`id`}
                    pagination={{
                        current, pageSize, total, position: ['bottomCenter'], showSizeChanger: true, showTotal: (total: number, range: [number, number]): any => (
                                <PaginatorTotal from={range[0]} to={range[1]} total={total}/>
                        ), locale:{ items_per_page: ""}
                    }}
            >
                { headers.map(header => {
                    if (propertyRoutes.findIndex(pr => pr.property === header) > -1) {
                        return (
                            <Table.Column<Role>
                                title={<Translate message={`role.field.${header}`} domain={TranslationDomainEnum.USER_ADMINISTRATION} />}
                                dataIndex={header}
                                key={header}
                                sorter={true}
                                render ={ _ => _ }
                            />
                        )
                    }

                    return (
                        <Table.Column<Role>
                            title={<Translate message={`role.field.${header}`} domain={TranslationDomainEnum.USER_ADMINISTRATION} />}
                            dataIndex={header}
                            sorter={true}
                            key={header}
                        />
                    )
                })}
                <Table.Column<Role> title={<Translate message={`global.actions`} domain={TranslationDomainEnum.MESSAGES} />} dataIndex={`actions`} key={`actions`} align={`right`}
                    render={(_, record) => <TableRowActions module={ module } record={ record } actions={ actions } />}
                />
            </Table>
        </Space>
    )
})